window.SA_loadCSS = function (href) {
  if (!href) return;
  if (document.querySelector('link[href="' + href + '"]')) return;

  var l = document.createElement('link');
  l.rel = 'stylesheet';
  l.href = href;
  document.head.appendChild(l);
};
